import { AuthContext } from "@/contexts/auth-context";
import { useState } from "react";
import { ELocalStorageKey } from "@/types/common";
import { authService } from "@/api/AuthService";
import { usersService } from "@/api/UsersService";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<string | null>(null);
  const getMe = async () => {
    try {
      const user = await usersService.getMe();
      if (user) {
        setUser(user.user?.id ?? null);
      }
      localStorage.setItem(ELocalStorageKey.UserId, user?.user?.id ?? "");
      localStorage.setItem(
        ELocalStorageKey.PassportId,
        user?.user?.passportId ?? "",
      );
    } catch (error) {
      console.log("Error fetching user data:", error);
      const passportUrl = await authService.getPassportLoginURL();
      if (passportUrl) {
        window.location.href = passportUrl;
      }
      console.error(error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, getMe }}>
      {children}
    </AuthContext.Provider>
  );
};
